import { render, staticRenderFns } from "./Configuracoes.vue?vue&type=template&id=10d64dc4"
import script from "./Configuracoes.vue?vue&type=script&lang=js"
export * from "./Configuracoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports